export default __webpack_public_path__ + "static/provider-cb-1782f27d756bf9312826d72144a5e2e0.jpg";